/**
 * Substring match — YMS uses `code.indexOf('UNKNOWN') !== -1` so any
 * code containing UNKNOWN (e.g. `UNKNOWN`, `UNKNOWN_LOCATION`)
 * qualifies as the displaced/unknown bucket. The reducer's optimistic
 * `isDisplaced` flip and the form's auto-force/no-banner UI must use
 * the same predicate to stay in sync.
 */
export const UNKNOWN_LOCATION_TOKEN = "UNKNOWN";

export const isUnknownDestination = (locationCode: string | undefined | null): boolean =>
  typeof locationCode === "string" && locationCode.includes(UNKNOWN_LOCATION_TOKEN);
